// src/components/eventos/views/EventoTV.js
// Rota pública permanente para TV/telão: /tv/:clienteId
// Mesma lógica de busca do EventoAoVivo, com layout otimizado para tela grande.

import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import EventoTVConteudo from './EventoTVConteudo';

const isUUID = (str) => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(str);

const EventoTV = ({ supabase }) => {
    const { clienteId: clienteParam } = useParams();
    const [evento, setEvento] = useState(null);
    const [cliente, setCliente] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [erro, setErro] = useState(null);

    useEffect(() => {
        const fetchEventoAtivo = async () => {
            try {
                let clienteData = null;
                if (isUUID(clienteParam)) {
                    const { data } = await supabase
                        .from('clientes').select('id, nome, logo_url').eq('id', clienteParam).maybeSingle();
                    clienteData = data;
                } else {
                    const { data } = await supabase
                        .from('clientes').select('id, nome, logo_url').eq('slug', clienteParam).maybeSingle();
                    clienteData = data;
                }
                if (clienteData) setCliente(clienteData);

                const resolvedId = clienteData?.id;
                if (!resolvedId) { setEvento(null); return; }

                // 1. Evento em andamento
                const { data: aoVivo, error: errAoVivo } = await supabase
                    .from('eventos').select('*')
                    .eq('cliente_id', resolvedId)
                    .eq('status', 'em_andamento')
                    .order('data', { ascending: true })
                    .limit(1)
                    .maybeSingle();
                if (errAoVivo) throw errAoVivo;

                if (aoVivo) { setEvento(aoVivo); return; }

                // 2. Próximo agendado
                const _d = new Date();
                const hoje = `${_d.getFullYear()}-${String(_d.getMonth()+1).padStart(2,'0')}-${String(_d.getDate()).padStart(2,'0')}`;
                const { data: proximo, error: errProximo } = await supabase
                    .from('eventos').select('*')
                    .eq('cliente_id', resolvedId)
                    .eq('status', 'agendado')
                    .gte('data', hoje)
                    .order('data', { ascending: true })
                    .limit(1)
                    .maybeSingle();
                if (errProximo) throw errProximo;

                setEvento(proximo || null);
            } catch (e) {
                setErro(e.message);
            } finally {
                setIsLoading(false);
            }
        };

        fetchEventoAtivo();
        const interval = setInterval(fetchEventoAtivo, 20000);
        return () => clearInterval(interval);
    }, [clienteParam, supabase]);

    if (isLoading) {
        return (
            <>
                <style>{`@keyframes tv-spin { to { transform: rotate(360deg); } }`}</style>
                <div style={{ position:'fixed', inset:0, background:'#0A1F3A', display:'flex', alignItems:'center', justifyContent:'center' }}>
                    <div style={{ width:44, height:44, borderRadius:'50%', border:'3px solid rgba(44,203,144,0.2)', borderTopColor:'#2CCB90', animation:'tv-spin 0.8s linear infinite' }} />
                </div>
            </>
        );
    }

    if (erro) {
        return (
            <div style={{ position:'fixed', inset:0, background:'#0A1F3A', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'Inter',-apple-system,sans-serif" }}>
                <p style={{ color:'#f87171', fontSize:18, fontWeight:600 }}>Link inválido</p>
            </div>
        );
    }

    return <EventoTVConteudo evento={evento} cliente={cliente} />;
};

export default EventoTV;
